import styled from "styled-components";
import { FieldSet } from "../../../../../App/Common/Components/FormComponents";
import { DropDownImage, DropDownMessage } from "../../../../../App/Common/Styles/DNDImage";

interface BackgroundImageProps {
  backgroundImage?: string | null;
}

export const PartImageDropZone = styled(DropDownImage as any)`
  width: 100%;
  height: auto;
  border-radius: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  border: none;
  background: #d9d9d9;
`;

export const OutlinedBox = styled.div<BackgroundImageProps>`
  width: 100%;
  height: 15rem;
  border: ${props => (props.backgroundImage ? "none" : "2px dashed #a3a3a3")};
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  background: ${props => (props.backgroundImage ? `url(${props.backgroundImage})` : "none")};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const ImageDropDownMessage = styled(DropDownMessage as any)<BackgroundImageProps>`
  font-size: 2.2rem;
  font-weight: 500;
  color: #a3a3a3;
  display: ${props => (props.backgroundImage ? "none" : "block")};
`;

export const ImageFieldSet = styled(FieldSet)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: none;

  label {
    width: 12%;
    font-size: ${({ theme }) => theme.fontSizes.regular};
    font-weight: 600;
  }

  input {
    width: 88%;
    font-size: 2rem;
    font-weight: 600;
    margin: 0px;
  }

  select {
    width: 88%;
  }

  @media (max-width: 768px) {
    label {
      width: 20%;
      font-size: 1.6rem;
    }

    input {
      width: 80%;
      font-size: 1.6rem;
    }
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60%;
  height: 100%;
  gap: 2rem;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ImageCheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 88%;
  padding-left: 12%;
`;

export const Checkbox = styled.input`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.3rem;
  transition: all 150ms;
  text-align: center;
  cursor: pointer;
  :hover {
    opacity: 0.7;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 5rem;
  gap: 8rem;
`;

interface TabOptions {
  active?: boolean;
  name?: string;
}

export const Tab = styled.div<TabOptions>`
  font-size: 2rem;
  font-weight: 400;
  color: #21394f;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: ${props => (props.active ? "#21394F" : "#d9d9d9")};
  text-underline-offset: 1rem;
`;

export const ImageUrlBox = styled(PartImageDropZone)`
  cursor: default;
  :hover {
    background: #d9d9d9;
    opacity: 1;
  }
`;

export const ImagePreview = styled.div`
  text-align: center;

  img {
    max-width: 100%;
  }
`;

export const AlignFormSelect = styled.select`
  height: 100%;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.large};
`;
